import { ReactComponent as ShipmentIcon } from "../../assets/icons/shipment.icon.svg";
import Tooltip from "../tooltips/tooltip";
import CreateShipmentModal from "../modals/shipments/create.shipment.modal";
import useModal from "../../hooks/other/useModal.other.hook";

const BottomNav = () => {
  const { isShowing, open, close } = useModal();

  const closeModal = () => {
    close();
  };

  return (
    <div className="z-30 justify-end w-full bg-gray-200 fixed bottom-0 h-[32px] px-8 flex items-center">
      <div className="flex items-center">
        <CreateShipmentModal isOpen={isShowing} onClose={closeModal} />
        <Tooltip text="Create Shipment" position="topLeft">
          <ShipmentIcon
            onClick={open}
            className="flex fill-secondary bg-greenGlass hover:bg-primary rounded p-1 cursor-pointer shadow-sm shadow-black backdrop-blur-sm"
          />
        </Tooltip>
      </div>
    </div>
  );
};

export default BottomNav;
